const header = {
	search: {
		no_results: "Keine Ergebnisse gefunden...",
		placeholder: "Suchen in der portal",
	},
	user_dropdown: {
		tabs: {
			cancel_impersonate: "Beenden Sie die Übernahme des Kontos",
			my_account: "Persönlich",
			my_company: "Unternehmen",
			sign_out: "Abmelden",
		},
	},
};

export default header;
